import {useEffect, useState} from "react";
import axiosInstance from "../../utils/axiosInstance";
import {IoArrowBackSharp} from "react-icons/io5";
import Loader from "../../components/Loader";

const ApplicationConfiguration = () => {
    const [bannerText, setBannerText] = useState("");
    const [uploaderText, setUploaderText] = useState("");
    const [minDtcPrice, setMinDtcPrice] = useState("");
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const fetchConfiguration = async () => {
            try {
                const response = await axiosInstance.get("/application-configuration");
                setBannerText(response.data?.header_banner_text || "");
                setUploaderText(response.data?.uploader_text || "");
                setMinDtcPrice(response.data?.min_dtc_price?.toString() || "");
            } catch (error) {
                console.error("Failed to load configuration", error);
                setMessage("Failed to load current configuration.");
            } finally {
                setLoading(false);
            }
        };

        fetchConfiguration();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        const minDtcPriceInt = parseInt(minDtcPrice, 10);
        if (isNaN(minDtcPriceInt) || minDtcPriceInt < 0) {
            setMessage("❌ Min DTC Price must be a non-negative integer.");
            setLoading(false);
            return;
        }

        try {
            await axiosInstance.post("/application-configuration", {
                header_banner_text: bannerText,
                uploader_text: uploaderText,
                min_dtc_price: minDtcPriceInt,
            });
            setMessage("✅ Updated successfully!");
        } catch (error) {
            console.error("Update failed", error);
            setMessage("❌ Failed to update.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader/>;
    }

    return (
        <div className="max-w-xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-lg">
            <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100 flex items-center">
                <button
                    onClick={() => window.history.back()}
                    className="rounded-full hover:bg-gray-200 transition-all mr-2"
                >
                    <IoArrowBackSharp size={24}/>
                </button>
                {" "}
                Configuration
            </h3>
            <form onSubmit={handleSubmit}>
                <label className="block mb-2 font-semibold text-gray-700">
                    Banner Text:
                </label>
                <textarea
                    value={bannerText}
                    onChange={(e) => setBannerText(e.target.value)}
                    rows={4}
                    className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <label className="block mb-2 font-semibold text-gray-700">
                    Uploader Text:
                </label>
                <textarea
                    value={uploaderText}
                    onChange={(e) => setUploaderText(e.target.value)}
                    rows={4}
                    className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <label className="block mb-2 font-semibold text-gray-700">
                    Min DTC Price:
                </label>
                <input
                    type="number"
                    min="0"
                    value={minDtcPrice}
                    onChange={(e) => setMinDtcPrice(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />

                <button
                    type="submit"
                    disabled={loading}
                    className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                    {loading ? "Saving..." : "Save"}
                </button>
            </form>

            {message && <div className="mt-4 text-sm text-gray-800">{message}</div>}
        </div>
    );
};

export default ApplicationConfiguration;
